import { QueryFunctionContext } from "@tanstack/react-query";

import { FiltersApiListIntegrationFilterOptionsRequest } from "../../api/v1";
import { API_LIMIT } from "../../utils/constants";
import useListQuery from "../../utils/use-list-query";

import useFiltersApi from "./use-filters-api";

const LIST_INTEGRATIONS_FILTERS_OPTIONS = "listIntegrationFilterOptions";

export default function useListIntegrationFilterOptions({
  limit,
  skip,
  scope,
  enabled,
}: FiltersApiListIntegrationFilterOptionsRequest & {
  enabled?: boolean;
}) {
  const api = useFiltersApi();

  const fetchMethod = async ({ pageParam = 0 }: QueryFunctionContext) => {
    const result = await api.listIntegrationFilterOptions({
      scope,
      limit: limit ?? API_LIMIT,
      skip: pageParam,
    });
    return result;
  };

  return useListQuery({
    fetchMethod,
    queryKey: [LIST_INTEGRATIONS_FILTERS_OPTIONS, scope],
    initialOffset: skip,
    enabled,
  });
}
